import { EnterIcon, IconButton } from "@minervaproject/fds";
import React from "react";

import { useAppDispatch, useAppSelector, useArraySelector } from "hooks/redux_hooks";
import { stopVisitingBreakoutRoom, visitBreakoutRoom } from "shared/reducers/classroom";
import { BreakoutRoomType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";

function VisitButtons({ breakoutRoom }: { breakoutRoom: BreakoutRoomType }) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const breakoutRooms = useArraySelector(
    classroomSelectors.selectBreakoutRoomsByBreakoutId(breakoutRoom.breakout_id),
  );
  const hasPreviousGroup = breakoutRoom.title !== "1";
  const hasNextGroup = breakoutRoom.title !== `${breakoutRooms.length}`;

  const handleGoBackToControlRoom = () => {
    dispatch(stopVisitingBreakoutRoom({ userId: currentUserId, breakoutRoomId: breakoutRoom.id }));
  };

  const handleGoToPreviousGroup = () => {
    const previousGroup = breakoutRooms.find(
      (_breakoutRoom) => _breakoutRoom.title === `${parseInt(breakoutRoom.title, 10) - 1}`,
    );
    if (previousGroup) {
      dispatch(visitBreakoutRoom({ userId: currentUserId, breakoutRoomId: previousGroup.id }));
    }
  };

  const handleGoToNextGroup = () => {
    const nextGroup = breakoutRooms.find(
      (_breakoutRoom) => _breakoutRoom.title === `${parseInt(breakoutRoom.title, 10) + 1}`,
    );
    if (nextGroup) {
      dispatch(visitBreakoutRoom({ userId: currentUserId, breakoutRoomId: nextGroup.id }));
    }
  };

  return (
    <div className="flex items-center">
      {hasPreviousGroup && (
        <IconButton className="mr4" onClick={handleGoToPreviousGroup}>
          <EnterIcon width={16} height={16} color="white" style={{ transform: "rotate(180deg)" }} />
          <span className="text-white ml1">Previous Group</span>
        </IconButton>
      )}

      <IconButton onClick={handleGoBackToControlRoom}>
        <EnterIcon width={16} height={16} color="white" style={{ transform: "rotate(270deg)" }} />
        <span className="text-white ml1">Back to Control Room</span>
      </IconButton>

      {hasNextGroup && (
        <IconButton className="ml4" onClick={handleGoToNextGroup}>
          <EnterIcon width={16} height={16} color="white" />
          <span className="text-white ml1">Next Group</span>
        </IconButton>
      )}
    </div>
  );
}

export { VisitButtons };
